import Chart from 'chart.js/dist/Chart.min.js';
import wNumb from 'wnumb';
import noUiSlider from 'nouislider';

const doughnutConfig = {
	type: 'doughnut',
	options: {
		cutoutPercentage: 80,
		legend : {
			display: false
		},
		tooltips : {
			backgroundColor : "rgba(255, 255, 255, 1)",
			bodyFontFamily : "'Titillium', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
			bodyFontColor : '#3C4F58',
			bodyFontSize: 30,
			footerFontFamily : "'Raleway', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
			footerFontColor : '#618293',
			footerFontSize: 15,
			displayColors: false,
			xPadding: 20,
			yPadding: 20,
			borderWidth: 1,
			borderColor: 'rgba(0,0,0,0.3)',
			callbacks: {
				label: function(tooltipItem, chart) {
					console.log(this);
					let number = chart.datasets[0].data[tooltipItem.index].toString()
					  , title = chart.labels[tooltipItem.index]
					  , diff = 0
					  , retval = '';

					if(typeof this._chart.options.appendages !== 'undefined'){
						// number += "\u202F";
						if(this._chart.options.appendages[tooltipItem.index] === "%"){
							number += "\uFE6A";
						} else {
							number += this._chart.options.appendages[tooltipItem.index];
						}
					}

					let numberLng = number.length * 30;
					let titleLng = title.length * 15;

					if(titleLng > numberLng){
						diff = (titleLng - numberLng) / 30;

						if(diff % 1 !== 0){
							retval += "\u202F";
						}

						for(let i = 0; i < Math.floor(diff); i++){
							retval += "\u00A0";
						}
					}

					retval += number;

					return retval;
				},
				footer: (tooltipItem, data) => {
					return `${data.labels[tooltipItem[0].index]}`;
				}
			}
		}
	}
};
const lineConfig = {
	type: 'line',
	data: {
		labels: ["20", "25", "30", "35", "40", "45", "50", "55", "60"],
		datasets: [{
			label: "Data",
			borderColor: "#27A3E2",
			pointBorderColor: "#DCDCDC",
			pointBackgroundColor: "#FFFFFF",
			pointHoverBackgroundColor: "#FFFFFF",
			pointHoverBorderColor: "#DCDCDC",
			pointRadius: 5,
			pointBorderWidth: 1,
			pointHoverRadius: 7,
			pointHoverBorderWidth: 2,
			fill: true,
			backgroundColor: "#27A3E2",
			borderWidth: 1,
			data: [550, 700, 950, 1450, 2200, 3300, 4900, 7750, 15000]
		}]
	},
	options: {
		legend: {
			// display: false
			position: 'bottom',
			labels : {
				boxWidth: 0,
				fontFamily: "'Raleway'",
				fontSize: 14,
				fontColor: '#3C4F58'
			}
		},
		tooltips : {
			backgroundColor: "rgba(255, 255, 255, 1)",
			bodyFontFamily: "'Titillium', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
			bodyFontColor: '#3C4F58',
			bodyFontSize: 14,
			titleFontFamily: "'Raleway', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
			titleFontColor: '#618293',
			titleFontSize: 14,
			displayColors: false,
			xPadding: 10,
			yPadding: 10,
			borderWidth: 1,
			borderColor: 'rgba(0,0,0,0.3)',
			callbacks: {}
		},
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true,
					padding: 10,
					fontFamily: "'Raleway'",
					fontSize: 14,
					fontColor: '#A3B8C3'
				},
				gridLines: {
					drawTicks: true,
					display: true,
					tickMarkLength: 0
				}
			}],
			xAxes: [{
				gridLines: {
					drawTicks: false,
					display: false
				},
				ticks: {
					padding: 10,
					fontFamily: "'Raleway'",
					fontSize: 14,
					fontColor: '#A3B8C3'
				}
			}]
		}
	}
};

export default {
	init: function(){
		if(document.querySelectorAll('.chart--doughnut') !== null){
			document.querySelectorAll('.chart--doughnut').forEach(el  => {
				this.doughnut.create(el);
			});
		}
		if(document.querySelectorAll('.chart--line') !== null){
			document.querySelectorAll('.chart--line').forEach(el => {
				this.line.create(el);
			});
		}
	},
	doughnut: {
		create: function(el) {
			let values = JSON.parse(el.dataset.values)
				, config = JSON.parse(el.dataset.config)
				, appendages = JSON.parse(el.dataset.appendages)
				, instanceConfig = Object.assign({}, doughnutConfig);

			instanceConfig.options.appendages = appendages;
			instanceConfig.data = config;
			instanceConfig.data.datasets[0].data = values[0];

			el.chart = new Chart(el.getContext('2d'), instanceConfig);

			el.range = noUiSlider.create(el.parentElement.nextElementSibling, {
				start : 1,
				step : 1,
				connect : [true, false],
				range : {
					'min' : 1,
					'max' : values.length
				},
				pips: { // Show a scale with the slider
					mode: 'steps',
					stepped: true,
					density: Math.round(100 / values.length),
					format: wNumb({
						decimals: 0,
						prefix: 'Lvl '
					})
				}
			});

			el.range.on('update', val => {
				el.chart.data.datasets[0].data = values[parseInt(val) - 1];
				el.chart.update();
				this.showTooltip(el.range, val);
				this.highlightPips(el.range, val);
			});

		},
		showTooltip : (parent, values) => {
			let step = parseInt(values[0]);

			$(parent.target).find('.noUi-popup').stop().fadeIn(150);

			if($(parent.target).find('.noUi-popup').length){
				$(parent.target).find('.noUi-popup').find('.amount').text(`Risk Level ${ step }`);
			} else {
				$(parent.target).find('.noUi-handle').append(`
				<div class="noUi-popup">
					<span class="h4 amount">Risk Level ${ step } </span>
				</div>
			`);
			}

			$(parent.target).siblings('.doughnut__step').find('span').text(`Risk Level ${ step }`);

			clearTimeout(parent.toolTipTimeout);
			parent.toolTipTimeout = setTimeout(() => {
				$(parent.target).find('.noUi-popup').stop().fadeOut(150);
			}, 2200);
		},
		highlightPips : (parent, values) => {
			parent.target.querySelectorAll('.noUi-value').forEach(el => {
				let val = parseInt(el.innerHTML.replace('Lvl ', ''));

				el.previousElementSibling.classList.remove('highlighted');

				if(val <= parseInt(values)){
					el.previousElementSibling.classList.add('highlighted');
				}
			});
		}
	},
	line: {
		create: function(el) {
			let xLabel = el.dataset.xlabel
			  , yPrefix = el.dataset.yprefix
			  , values = JSON.parse(el.dataset.values)
			  , labels = JSON.parse(el.dataset.labels)
			  , instanceConfig = Object.assign({}, lineConfig);

			instanceConfig.data.datasets[0].label = xLabel;
			instanceConfig.data.datasets[0].data = values;
			instanceConfig.data.labels = labels;

			// instanceConfig.options.scales.yAxes[0].ticks.stepSize = Math.max.apply(null, values) / values.length;

			instanceConfig.options.tooltips.callbacks.label = function(tooltipItem, chart){
				let number = chart.datasets[0].data[tooltipItem.index].toLocaleString().toString();

				return `${yPrefix}${number}`;
			};

			instanceConfig.options.tooltips.callbacks.title = function(tooltipItem, data){
				let suffix = data.labels[tooltipItem[0].index]
				  , prefix = data.datasets[0].label;

				return `${prefix}: ${suffix}`;
			};

			instanceConfig.options.scales.yAxes[0].ticks.callback = function(value, index, values) {
				return '£' + value.toLocaleString();
			};

			el.line = new Chart(el, instanceConfig);
		}
	}

}
